/**
 * Reusable status chip. Pass label dict { color, label } from dictionaries.js.
 */
export default function StateBadge({ value, dict, testId }) {
    const entry = dict?.[value];
    if (!entry) {
        return (
            <span className="zentra-chip bg-zentra-bg text-zentra-ink border-zentra-border" data-testid={testId}>
                {value || "—"}
            </span>
        );
    }
    return (
        <span className={`zentra-chip ${entry.color}`} data-testid={testId}>
            {entry.label}
        </span>
    );
}
